// Which frame the shell is drawing, for the few web-only component siblings
// that need to adapt (e.g. src/components/OrnamentBackground.web.tsx spans
// the whole viewport on the logged-out desktop frame). Provided by WebShell.

import { createContext, useContext } from 'react';

export type Frame = 'phone' | 'tablet' | 'auth' | 'app';

export const FrameContext = createContext<Frame>('phone');

export function useFrame(): Frame {
  return useContext(FrameContext);
}
